import { Image, StyleSheet, Text, View } from "react-native";
import React from "react";
const logo = require("../../assets/images/logoisic.png");

const Header = () => {
  return (
    <View style={styles.root}>
      <Image source={logo} style={styles.logo} resizeMode="contain" />
    </View>
  );
};

export default Header;

const styles = StyleSheet.create({
  root: {
    width: "100%",
    height: 70,
    backgroundColor: "#fff",
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,

    elevation: 5,
    justifyContent: "center",
    paddingLeft: "5%",
    zIndex: 5,
  },
  logo: {
    height: 70,
    width: 160,
  },
});
